import ApiRequestManagerInstance from '../ApiRequestManager';

function addPlanRequest(data?: {
  addonPlanCode?: string;
  channelCode?: string;
  planId?: string;
  functionality?: string;
}) {
  return ApiRequestManagerInstance.post({
    endpoint: {
      url: 'apiUrl',
      version: 'v4',
      section: 'user',
      subsection: 'addPlan',
    },
    data,
  });
}

export default addPlanRequest;
